var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5V18H8v-1.5h8zm4.5-4.5A4.5 4.5 0 0016 7.5H8a4.5 4.5 0 000 9V18l-.309-.008A6 6 0 018 6h8a6 6 0 010 12v-1.5a4.5 4.5 0 004.5-4.5z",
    fill: "currentColor"
  })));
}
SvgPokerTable.displayName = 'PokerTable';
export default SvgPokerTable;